import React from "react";
import { Link } from "react-router-dom";
import { LOGO } from "../../lib/assets";

export const FooterTwo = () => {
  return (
    <footer>
      <div className="footer-area-two footer-bg-two">
        <div className="footer-top-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <div className="fw-logo">
                    <Link to="/">
                      <img src={LOGO} alt="" />
                    </Link>
                  </div>

                  <div className="footer-content">
          <p> M/s BLAK & CO. (Company Secretaries) and M/s GOBIZ LEGAL (Law Firm) form a distinguished professional alliance dedicated to delivering comprehensive, strategic, and solution-oriented legal, secretarial, and regulatory services.
                    </p>
                    <div className="footer-info">
                      <ul className="list-wrap">
                        <li>
                          <div className="icon">
                            <i className="flaticon-phone-call"></i>
                          </div>
                          <div className="content">
                            <a href="tel:0123456789"> 9990573703 </a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <i className="flaticon-clock"></i>
                          </div>
                          <div className="content">
                            <p>
                              Mon – Sat: 8 am – 5 pm, <br />
                              Sunday: <span>CLOSED</span>
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Menu</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/"> Home </Link>
                      </li>
                      <li>
                        <Link to="/about-us"> About us </Link>
                      </li>
                      <li>
                        <Link to="/industries">Industries </Link>
                      </li>
                      <li>
                        <Link to="/blog"> Resources </Link>
                      </li>
                      <li>
                        <Link to="/contact">Privacy Policy</Link>
                      </li>
                       <li>
                        <Link to="/contact-us"> Contact us </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title"> Services  </h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/contact"> Company Secretarial Services </Link>
                      </li>
                      <li>
                        <Link to="/contact"> Legal Services </Link>
                      </li>
                      <li>
                        <Link to="/contact"> Consultancy Services </Link>
                      </li>
                      
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">Our Newsletter</h4>
                  <div className="footer-newsletter">
                    <p>
                      Sign up to Privitar’s weekly newsletter to get the latest
                      updates.
                    </p>
                    <form action="#">
                      <input type="email" placeholder="enter your e-mail" />
                      <button type="submit">Subscribe</button>
                    </form>
                    <div className="footer-social footer-social-two">
                      <ul className="list-wrap">
                        <li>
                         <Link to='#'>
                            <i className="fab fa-facebook-f"></i>
                         </Link>
                        </li>
                        <li>
                          <Link to='#'>
                            <i className="fab fa-twitter"></i>
                          </Link>
                        </li>
                        <li>
                        <Link to='#'>
                            <i className="fab fa-instagram"></i>
                          </Link>
                        </li>
                        <li>
                        <Link to='#'>
                            <i className="fab fa-pinterest-p"></i>
                          </Link>
                        </li>
                        <li>
                          <Link to='#'>  <i className="fab fa-youtube"></i> </Link>
                         
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text-two text-center">
                  <p>  © Globizindia | All Right Reserved Designed & Developed By <Link to='https://1technologies.in/'> <b> 1Technologies </b>  </Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
